import React from 'react'
import Header from './Reusables/Header'
import DownloadImg from "../assests/download.svg";
import REPHQCheckTable from './Tables/REPHQCheckTable';
import axiosRequest from "../api/axios";
import SnackBarComponent from "./Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import { CSVLink } from "react-csv";
import PeriodSelector from './PeriodSelector';
const ADjustedCheckREPHQ = () => {
  const [filtersData, setfiltersData] = React.useState({});
  const [brandListData, setbrandListData] = React.useState([]);
  const [productListData, setproductListData] = React.useState([]);
  const [selectedProduct, setselectedProduct] = React.useState("");
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [rows, setrows] = React.useState([]);
  const [loaderFilter, setLoaderFilter] = React.useState(false);
  const [Quarter, setQuarter] = React.useState("");
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");
  const [selectedRbm, setselectedRbm] = React.useState("");
  const [RbmListData, setRbmListData] = React.useState([]);
  const [filtersDataSum, setfiltersDataSum] = React.useState({});
  let sum_data = {
    m1_unadj_val : 0, 
        m1_adj_val :0, 
        m2_unadj_val : 0, 
        m2_adj_val :0, 
        m3_unadj_val : 0, 
        m3_adj_val :0, 
  }
  const api_headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+localStorage.getItem("Token")
  }
  
  let RbmListComponent = [];
  RbmListData.forEach((item, index) => {
    RbmListComponent.push(<option key={index}>{item}</option>);
  });
  let brandComponent = [];
  brandListData.forEach((item, index) => {
    brandComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
 
  const handleChangeBrand = (event) => {
    const temp = event.target.value;
    // let prodlist=[]
    // for (let item of filtersData) {
    //   if(item['brandname'] == temp){
    //     prodlist = [...item["productname"]]
    //   }
    // }
   
    // setproductListData(prodlist)
    // setselectedProduct(prodlist[0])
    setselectedBrand(temp);
   
  };
  
 
  const handleClose = () => {
    setOpensb(false);
  };
 

//   const handleChangeProduct = (event) => {
//     const temp = event.target.value;
//     setselectedProduct(temp);
   
//   };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };
 const handleChangeRbm = (event) => {
    setselectedRbm(event.target.value);
    // let brandlist = ["All"]
    // // let prodList = ["All"]
    // for (let item of filtersData) {
    //   if (item["abmname"] === event.target.value) {
        
    //       brandlist.push(...item['brandname'])
    //   } 
    // }
    
   
    // setbrandListData(brandlist);
    setselectedBrand('All');
    // let prodlist=['All']
    // setproductListData(prodList)
    // setselectedProduct('All');
    // if( event.target.value == 'All'){
    
     
    // }
  };

  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getfiltered_adjusted_check_rephqdata",
      method: "POST",
      headers: api_headers,
      data: {
        abmname:selectedRbm,
        brandname: selectedBrand,
        rbmcode:localStorage.getItem("rbmcode"),
        teamcode: localStorage.getItem("teamcode"),
        quarter:localStorage.getItem("quarter"),
        year:localStorage.getItem("year"),

      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        let tot_data = data?.data?.data
        let m1_unadj_val = 0 
        let m1_adj_val =0 
        let m2_unadj_val = 0 
        let m2_adj_val =0 
        let m3_unadj_val = 0 
        let m3_adj_val =0 
        
        for (let i = 0; i < tot_data?.length; i++) { 
           m1_unadj_val = m1_unadj_val+ parseFloat(tot_data[i]["m1_unadjusted_budget_value"] != null ? tot_data[i]["m1_adjusted_budget_value"] : 0)
          m1_adj_val = m1_adj_val + parseFloat( tot_data[i]["m1_adjusted_budget_value"] != null ? tot_data[i]["m1_adjusted_budget_value"] : 0)
          m2_unadj_val = m2_unadj_val+ parseFloat(tot_data[i]["m2_unadjusted_budget_value"] != null ? tot_data[i]["m2_unadjusted_budget_value"] : 0)
          m2_adj_val = m2_adj_val + parseFloat(tot_data[i]["m2_adjusted_budget_value"] != null ? tot_data[i]["m2_adjusted_budget_value"] : 0)
          m3_unadj_val = m3_unadj_val+ parseFloat(tot_data[i]["m3_unadjusted_budget_value"] != null ? tot_data[i]["m3_unadjusted_budget_value"] : 0)
          m3_adj_val = m3_adj_val + parseFloat(tot_data[i]["m3_adjusted_budget_value"] != null ? tot_data[i]["m3_adjusted_budget_value"] : 0)
          
        }
     
        sum_data['m1_unadj_val'] = parseFloat(m1_unadj_val).toFixed( 2 );
        sum_data['m1_adj_val'] = parseFloat(m1_adj_val).toFixed( 2 );
        sum_data['m2_unadj_val'] = parseFloat(m2_unadj_val).toFixed( 2 );
        sum_data['m2_adj_val'] = parseFloat(m2_adj_val).toFixed( 2 );
         sum_data['m3_unadj_val'] = parseFloat(m3_unadj_val).toFixed( 2 );
        sum_data['m3_adj_val'] = parseFloat(m3_adj_val).toFixed( 2 );
        setfiltersDataSum(sum_data)
        handleSnackBar("Data Loaded Successfully", "success");
        // setfiltersOutputData()
       
      } else {
        
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };


  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/getfiltersdatarbmbrand",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: localStorage.getItem("teamcode"),
        rbmcode:localStorage.getItem("rbmcode"),
        year:localStorage.getItem("year"),
        quarter:localStorage.getItem("quarter"),

      },
    }).then((data) => {
      if (data.status === 200) {
        // const temp_list = ["All"];

        setfiltersData(data?.data?.data);
        // for (let rbm of data?.data?.data) {
        //   temp_list.push(rbm["abmname"]);
        // }
        setRbmListData(data?.data?.data?.abmlist);
        // for (let brand of data?.data?.data) {
        //   temp_list.push(brand["brandname"]);
        // }
        setbrandListData(data?.data?.data?.brandlist)
       
        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
        
      }
    });
  };
  React.useEffect(() => {
    getfiltersdata();
    // gettabledata();
    setQuarter(localStorage.getItem('quarter'))
    //logic to display month name based on Quarter
    if (localStorage.getItem('quarter') == "Q1") {
      setMonth1("Jan");
      setMonth2("Feb");
      setMonth3("Mar");
    } else if (localStorage.getItem('quarter') == "Q2") {
      setMonth1("Apr");
      setMonth2("May");
      setMonth3("Jun");
    } else if (localStorage.getItem('quarter') == "Q3") {
      setMonth1("Jul");
      setMonth2("Aug");
      setMonth3("Sep");
    } else if (localStorage.getItem('quarter') == "Q4") {
      setMonth1("Oct");
      setMonth2("Nov");
      setMonth3("Dec");
    }
  }, []);
  let columns_buh = [
    { key: "id", label: "ID"},
    {
        key: 'repname',
        label: 'REP Name',
        
      },
    {
      key: 'brand',
      label: 'Brand',
      
    },
    {
      key: 'm1_unadjusted_budget_value',
      label: String(Month1)+' UnAdj.Bug Val',
     
    },
    {
      key: 'm1_adjusted_budget_value',
      label: String(Month1)+' Adj.Bug Val',
      
    },
    {
      key: 'm1_difference',
      label: String(Month1)+' Difference',
      
    },
    {
      key: 'm2_unadjusted_budget_value',
      label: String(Month2)+' UnAdj.Bug Val',
     
    },
    {
      key: 'm2_adjusted_budget_value',
      label: String(Month2)+' Adj.Bug Val',
      
    },
    {
      key: 'm2_difference',
      label: String(Month2)+' Difference',
      
    },
    {
      key: 'm3_unadjusted_budget_value',
      label: String(Month3)+' Adj.Bug Val',
     
    },
    {
      key: 'm3_adjusted_budget_value',
      label: String(Month3)+' Adj.Bug Val',
      
    },
    {
      key: 'm3_difference',
      label: String(Month2)+' Difference',
      
    },
  ];
  
  return (
    <div className='bg-white home-screen'>
      <p style={{fontWeight:"550"}}>Adjusted Check ABM</p>
      <PeriodSelector/>
       <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
         <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "5px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              ABM Name
            </label>
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeRbm(event)}
            >
              {loaderFilter === true ? (
                <option value="">
                  Loading...
                </option>
              ) : (
                <option value="">select abm name</option>
                
              )}
              {/* <option value="All">All</option> */}
              {RbmListComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>
            <select
              className="filter-style"
              id="brand"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeBrand(event)}
              value={selectedBrand}
            >
               <option value="">select brand</option>
               {/* <option value="All">All</option> */}
              {brandComponent}
            </select>
          </div>
          
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <button className="submit-btn" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
        <div>
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
            <CSVLink data={rows} headers={columns_buh} filename={"Adjusted_Check_Rephq Summary.csv"} style={{textDecoration:"none",color:"black"}}>Download</CSVLink>
          </button>
        </div>
      </div>
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
          }}
        >
          <CircularProgress color="inherit" display={loader===true?"true":"false"} />
        </div>
      ):(
      <REPHQCheckTable rows={rows} Month1={Month1}
      Month2={Month2} 
      Month3={Month3}/>)}
            {loader === false ?(<div
          style={{
           
           height:"135px",
           width:"100%",
           marginBottom:"10px"
           
          }}
        >
        <table className='table-buh'>
    <tr className="table-tr-td-buh">
    <th className="table-tr-td-buh"></th>
      <th className="table-tr-td-buh">UnAdj.bud v ({Month1})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month1})</th>
      <th className="table-tr-td-buh">Difference ({Month1})</th>

      <th className="table-tr-td-buh">UnAdj.bud v ({Month2})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month2})</th>
      <th className="table-tr-td-buh">Difference ({Month2})</th>

      <th className="table-tr-td-buh">UnAdj.bud v ({Month3})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month3})</th>
      <th className="table-tr-td-buh">Difference ({Month3})</th>

      
    </tr>
    <tr className="table-tr-td-buh">
      <td className="table-tr-td-buh">Total</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_unadj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_adj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_difference']}</td>

      <td className="table-tr-td-buh">{filtersDataSum['m3_unadj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_adj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_difference']}</td>

      <td className="table-tr-td-buh">{filtersDataSum['m3_unadj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_adj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_difference']}</td>

    </tr>
  </table>
        </div>):""}
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
        autoHideDuration={6000}
      />
    </div>
  )
}

export default ADjustedCheckREPHQ
